module.exports = __webpack_public_path__ + "static/media/recepcionista.9124d328.svg";